import { gql } from '@apollo/client';

export default gql`
  query getUrgentOperations(
    $opType: Int
    $dcategoryId: String
    $start: Date
    $end: Date
  ) {
    getFormOperations(
      opType: $opType
      dcategoryId: $dcategoryId
      start: $start
      end: $end
    ) {
      ok
      error
      data {
        _id
        id
        time
        opType
        branch
        title
        desc
        startDate
        endDate
        priority
        status
        autoNo
        docNo

        customerId
        customerName
        customerNameAr
        customerPhone

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr

        contactId
        contactName
        contactNameAr
        contactPhone

        userId
        createdAt
        updatedAt
      }
    }
  }
`;
